import { useEffect } from "react";

// Canonical production origin — always used for canonical/OG URLs regardless of preview host.
export const SITE = "https://askmydr.net";
export const DEFAULT_OG = `${SITE}/og-default.jpg`;

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Declaratively manages <title>, meta, canonical, OG/Twitter and JSON-LD.
// Works with react-snap: the tags are written into the DOM head before snapshot.
export function Seo({ title, description, path = "", image, type = "website", jsonLd }) {
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_OG;
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:site_name", "AskMyDoctor AI");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    const id = "amd-jsonld";
    let s = document.getElementById(id);
    if (ld) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = id;
        document.head.appendChild(s);
      }
      s.textContent = ld;
    } else if (s) {
      s.remove();
    }
  }, [title, description, url, img, type, ld]);

  return null;
}
